export default "__VITE_ASSET__Dftc7MOj__"